export const verificationEntityType = {
  partner: "Partner",
  item: "Item"
};
